import {
  Component, EventEmitter, HostBinding, Input,
  Output,
} from '@angular/core';
import {Message} from '@catui/components/button/types';
import {StyleType} from '@catui/types';

const componentBaseName = 'button';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-button',
  styleUrls: ['./button.component.scss'],
  templateUrl: './button.component.html',
})
export class ButtonComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() label: string;
  @Input() type = StyleType.default;
  @Input() disabled = false;
  @Input() click = new EventEmitter<any>();
  @Input() toggleButton = false;
  @Input() toggleStateActive = false;
  @Input() faIcon = null;

  constructor() {
  }

  onClick(){
    if (this.toggleButton) {
      this.toggleStateActive = !this.toggleStateActive;
      this.click.emit(this.toggleStateActive);
    } else {
      this.click.emit();
    }
  }

  get isDefault(){ return this.type === StyleType.default; }
  get isAlert(){ return this.type === StyleType.alert && !this.disabled; }
  get isWarning(){ return this.type === StyleType.warning && !this.disabled; }
  get isSuccess(){ return this.type === StyleType.success && !this.disabled; }
  get isToggleStateActive(){ return this.toggleStateActive && !this.disabled; }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/button/button.component.ts